module.exports = __webpack_public_path__ + "static/how_it_works_art-a267cc8b0883be24e1dcc93f722d0212.png";